import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShoppingBagIcon, ArrowLeftIcon, TrashIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { CartItem } from '../components/cart/CartItem';
import { CartSummary } from '../components/cart/CartSummary';
import { useCart } from '../context/CartContext';
export function CartPage() {
  const {
    cart,
    clearCart,
    totalItems
  } = useCart();
  const [promoCode, setPromoCode] = useState('');
  if (cart.length === 0) {
    return <main className="min-h-screen bg-slate-50" data-id="element-459">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-460">
          <div className="text-center" data-id="element-461">
            <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-462">
              <ShoppingBagIcon className="w-12 h-12 text-slate-400" data-id="element-463" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-464">
              Кошик порожній
            </h1>
            <p className="text-slate-600 mb-8" data-id="element-465">
              Додайте товари з каталогу, щоб оформити замовлення
            </p>
            <Link to="/catalog" data-id="element-466">
              <Button size="lg" data-id="element-467">Перейти в каталог</Button>
            </Link>
          </div>
        </div>
      </main>;
  }
  return <main className="min-h-screen bg-slate-50" data-id="element-468">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-469">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-470">
          <nav className="flex items-center gap-2 text-sm" data-id="element-471">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-472">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-473">/</span>
            <span className="text-slate-900 font-medium" data-id="element-474">Кошик</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-475">
        {/* Header */}
        <div className="flex items-center justify-between mb-8" data-id="element-476">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-477">
            Кошик{' '}
            <span className="text-slate-500 font-normal text-xl" data-id="element-478">
              ({totalItems} товарів)
            </span>
          </h1>
          <button onClick={clearCart} className="flex items-center gap-2 text-sm text-slate-500 hover:text-red-500 transition-colors" data-id="element-479">
            <TrashIcon className="w-4 h-4" data-id="element-480" />
            Очистити кошик
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-481">
          {/* Cart Items */}
          <div className="lg:col-span-2" data-id="element-482">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="bg-white rounded-2xl shadow-md p-6" data-id="element-483">
              {cart.map(item => <CartItem key={item.id} item={item} data-id="element-484" />)}
            </motion.div>

            {/* Promo Code */}
            <div className="bg-white rounded-2xl shadow-md p-6 mt-6" data-id="element-485">
              <h3 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-486">
                Промокод
              </h3>
              <div className="flex gap-3" data-id="element-487">
                <Input value={promoCode} onChange={e => setPromoCode(e.target.value)} placeholder="Введіть промокод" className="flex-1" data-id="element-488" />
                <Button variant="outline" data-id="element-489">Застосувати</Button>
              </div>
            </div>

            {/* Continue Shopping */}
            <Link to="/catalog" className="inline-flex items-center gap-2 mt-6 text-sky-600 hover:text-sky-700 font-medium" data-id="element-490">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-491" />
              Продовжити покупки
            </Link>
          </div>

          {/* Summary */}
          <div className="lg:col-span-1" data-id="element-492">
            <div className="sticky top-24" data-id="element-493">
              <CartSummary data-id="element-494" />
            </div>
          </div>
        </div>
      </div>
    </main>;
}